import Vue from 'vue'
import store from "./vuex/store";
import App from './App.vue'
import Storage from 'vue-web-storage';
import VueSessionStorage from 'vue-sessionstorage';
import { HTTP } from './http-common';
import router from "./router";
import {customSwal} from "@/assets/js/sweetalert";
import VueCryptojs from 'vue-cryptojs/src/index.mjs';

Vue.config.productionTip = false

Vue.use(Storage);
Vue.use(VueSessionStorage);
Vue.use(VueCryptojs);

//Js SDK init
const KAKAO_API_KEY = 'b478958f110669aa909c45f57363977f';
window.Kakao.init(KAKAO_API_KEY);

Vue.prototype.$http = HTTP;
Vue.prototype.$swal = customSwal;

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';

new Vue({
  router,
  HTTP,
  store,
  Storage,
  render: h => h(App),
}).$mount('#app')
